import { SvgAsset, type TSvgAssetProps } from '../../components/svgAsset/SvgAsset';

const PortOfLoading = (props: TSvgAssetProps) => (
  <SvgAsset width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8535 4.64646C15.7196 4.51254 15.5215 4.46578 15.3419 4.52567L4.84187 8.02567C4.60923 8.10322 4.46716 8.33804 4.50644 8.5801C4.54572 8.82217 4.75476 9.00001 4.99999 9.00001H8.49999V9.76583L5.67989 12.1159C5.5659 12.2109 5.49999 12.3516 5.49999 12.5V16C5.49999 16.2762 5.72384 16.5 5.99999 16.5H12C12.2761 16.5 12.5 16.2762 12.5 16V12.5C12.5 12.3516 12.4341 12.2109 12.3201 12.1159L9.49999 9.76583V9.00001H15V19C15 19.2762 15.2238 19.5 15.5 19.5C15.7761 19.5 16 19.2762 16 19V9.00001H19C19.2022 9.00001 19.3845 8.87819 19.4619 8.69136C19.5393 8.50452 19.4965 8.28946 19.3535 8.14646L15.8535 4.64646ZM15 8.00001H8.99999H8.08112L15 5.69373V8.00001ZM16 6.20712V8.00001H17.7929L16 6.20712ZM8.99999 10.6509L10.619 12H7.38101L8.99999 10.6509ZM6.49999 13H11.5V15.5H6.49999V13Z"
    />
  </SvgAsset>
);

export default PortOfLoading;
